export { Speedometer as default } from './Speedometer';
